import { render, staticRenderFns } from "./CidadeModal.vue?vue&type=template&id=52bc6d05&scoped=true"
import script from "./CidadeModal.vue?vue&type=script&lang=js"
export * from "./CidadeModal.vue?vue&type=script&lang=js"
import style0 from "./CidadeModal.vue?vue&type=style&index=0&id=52bc6d05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc6d05",
  null
  
)

export default component.exports